import { ADMIN_URL, APP_BASE_URL } from '../../config/api';
import { authFetch } from '../../utils/api';
// authFetch does NOT prepend APP_BASE_URL, so we must include it in URLs
const RULES_URL = `${APP_BASE_URL}${ADMIN_URL}/rules`;
const ENTITIES_URL = `${APP_BASE_URL}${ADMIN_URL}/entities`;

export async function listRules(accountId) {
  const res = await authFetch(`${ENTITIES_URL}/${accountId}/rules`);
  if (!res.ok) throw new Error("Failed to fetch rules");
  return res.json();
}

export async function createRule(payload) {
  console.log("createRule: ", payload);
  const res = await authFetch(RULES_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let errBody = null;
    try { errBody = await res.json(); } catch(e) { errBody = await res.text(); }
    console.error("createRule POST error:", { status: res.status, response: errBody, sentPayload: payload });
    throw new Error(errBody?.detail || `Failed to create rule: ${res.status}`);
  }
  return res.json();
}

export async function updateRule(id, payload) {
  console.log("updateRule: attempting PATCH with payload:", payload);
  const res = await authFetch(`${RULES_URL}/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let errBody = null;
    try { errBody = await res.json(); } catch(e) { errBody = await res.text(); }
    console.error("updateRule PATCH error:", { status: res.status, response: errBody, sentPayload: payload });
    throw new Error(errBody?.detail || `Failed to update rule: ${res.status}`);
  }
  return res.json();
}

export async function deleteRule(id) {
  const res = await authFetch(`${RULES_URL}/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error("Failed to delete rule");
}

export async function createDefaultRules(accountId) {
  const res = await authFetch(`${ENTITIES_URL}/${accountId}/default-rules`, {
    method: "POST",
    headers: { "Content-Type": "application/json" }
  });

  if (!res.ok) throw new Error("Failed to create default rules");
  return res.json();
}